import intercom from '../Utils/Intercom'


export default function ({ store, app }) {
    const user = store.$auth.user
    intercom.update(user, app?.i18n?.locale ?? 'ar')
}
